import computerRepair from '../../images/featured/computer-repair.jpg';
import dataRecovery from '../../images/featured/data-recovery.jpg';
import computerSetup from '../../images/featured/computer-setup.jpg';
import homeNetwork from '../../images/featured/home-network.jpg';

export const featuredItems = [
  {
    name: 'Computer - Installation, Configuration, Fixing',
    details: 'We can help set up your computer and configure it to your liking as well as fixing or troubleshoot any issues concerning it.',
    slug: '',
    image: computerRepair
  },
  {
    name: 'Data Backup, Restore, Recovery',
    details: 'Our geeks will make sure you never lose your data by backing up and recovering your data at utmost proficiency.',
    slug: '',
    image: dataRecovery
  },
  {
    name: 'New Computer Setup',
    details: 'Our geeks will be able to provide insights and useful tips so that you know what set up will be best for you as well as assist you with setting up and readying your computer to your liking.',
    slug: '',
    image: computerSetup
  },
  {
    name: 'Home Network Setup',
    details: 'We will be able to set up and optimize WIFI network in your homes so that you can seamlessly browse the internet throughout your house with no trouble at all.',
    slug: '',
    image: homeNetwork
  }
];

export const reviews = [
  {
    id: 1,
    name: 'Evans',
    photo: 'avatar-01.jpg',
    date: 'January 12, 2020',
    value: 3,
    content: '10/10, very personable and very  honest would use again, and recommend to anyone who asked, thankyou'
  },
  {
    id: 2,
    name: 'Jim Ruming',
    date: 'September 21, 2019',
    value: 4,
    content: 'Impressed at the net speed boost after getting WiFi optimized '
  },
  {
    id: 3,
    name: 'Christopher',
    date: 'December 12, 2019',
    value: 5,
    content: 'Installed server for my business office, things are more well managed now'
  },
  {
    id: 4,
    name: 'Jayden',
    date: 'February 3, 2020',
    value: 5,
    content: 'Very happy with the service  and Luis C was extremely helpful'
  },
  {
    id: 5,
    name: 'Tim Martin',
    date: 'February 8, 2020',
    value: 5,
    content: 'This company is really good at onsite repair services, not kidding'
  }
];